import { render } from "./Formato2010.vue?vue&type=template&id=13595d64&scoped=true"
import script from "./Formato2010.vue?vue&type=script&lang=js"
export * from "./Formato2010.vue?vue&type=script&lang=js"

import "./Formato2010.vue?vue&type=style&index=0&id=13595d64&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13595d64"]])

export default __exports__